<template>
  <div class="ui-content dashboard add-ch-arrow user-section">
    <v-card class="mx-auto normal-card autohg">
      <div class="add-user-form">
        <v-row>
          <v-col cols="12" sm="4" class="blk"></v-col>
          <v-col cols="12" sm="4" class="b-data">
            <v-text-field
              v-model="name"
              label="Name"
              hide-details
              dense
              outlined
              class="required"
            ></v-text-field>
            <InputError :data="error.name" />
          </v-col>
          <v-col cols="12" sm="4" class="blk"></v-col>
          <v-col cols="12" sm="4" class="blk"></v-col>
          <v-col cols="12" sm="4" class="b-data">
            <v-text-field
              v-model="email"
              label="Email ID"
              hide-details
              dense
              outlined
              class="required"
            ></v-text-field>
            <InputError :data="error.email" />
          </v-col>
          <v-col cols="12" sm="4" class="blk"></v-col>
          <v-col cols="12" sm="4" class="blk"></v-col>
          <v-col cols="12" sm="4" class="b-data">
            <multi-select
              allText="All Centers"
              :items="centers"
              ref="centerSelect"
              :onChange="onCenterchange"
              v-model="selectedCenterId"
              label="Centers"
              hide-details
              dense
              outlined
              class="fix-200 required fonts"
              filled
            ></multi-select>
            <InputError :data="error.center" />
          </v-col>
          <v-col cols="12" sm="4" class="blk"> </v-col>
          <v-col cols="12" sm="4" class="blk"> </v-col>
          <v-col cols="12" sm="4" class="rg-0 b-data">
            <v-btn
              @click="onSubmit"
              :loading="loading"
              class="right-btn cust-btn"
              color="primary"
              >Done</v-btn
            >
          </v-col>
          <v-col cols="12" sm="4" class="blk"> </v-col>
        </v-row>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
  name: "UsersParents",
   props: ["tab"],

  data() {
    return {
      items: ["All", "xyz"],
      height: null,
      loading: false,
      singleSelect: false,
      selected: [],
      email: null,
      name: null,
      error: {
        email: {
          type: null,
          message: null,
        },
        name: {
          type: null,
          message: null,
        },
        center: {
          type: [],
          message: null,
        },
      },
      centers: [],
      selectedCenterId: [],
    };
  },
  methods: {
    ...mapActions({
      signUp: "userStore/signUp",
      getCenters: "centerAndBatchStore/getCentersByUser",
    }),
    onSubmit() {
      this.loading = true;
      if (this.validate()) {
        this.signUp({
          internal: true,
          name: this.name.trim(),
          email: this.email.trim(),
          role_id: this.roleIds.CO,
          center_id: this.selectedCenterId,
        })
          .then((response) => {
            this.loading = false;
            this.email = "";
            this.name = "";
            this.selectedCenterId = [];
            this.$refs.centerSelect.clearAllSelection();
            this.$toasted.success(`${response.message}`, {
              icon: "check_circle", className:'new-class'
            });
            this.loading = false;
            this.requestGetCenters();
          })
          .catch((err) => {
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    },
    // this.selectedBatch = null;
    validate() {
      this.email = this.removeWhiteSpacesFromEmail(this.email);
      let isValid = true;
      this.error.name.type = null;
      this.error.email.type = null;
      this.error.center.type = [];
      if (!this.name || this.name.trim().length < 1) {
        this.error.name.type = "error";
        this.error.name.message = "Please enter name";
        isValid = false;
      }
      if (this.name && this.name.trim().length > 70) {
        this.error.name.type = "error";
        this.error.name.message = "Name should not contain more than 70 characters";
        isValid = false;
      }
      if (!this.selectedCenterId.length > 0) {
        this.error.center.type = "error";
        this.error.center.message = "Please select Center.";
        isValid = false;
      }
      if (!this.email || this.email.length < 1) {
        this.error.email.type = "error";
        this.error.email.message = "Please enter email ID.";
        isValid = false;
      } else if (!this.isValidEmail(this.email)) {
        this.error.email.type = "error";
        this.error.email.message =
          "Please enter a valid email ID.";
        isValid = false;
      }
      return isValid;
    },

    requestGetCenters() {
      this.centers = [];
      this.$root.showLoader = true;
      this.getCenters()
        .then((response) => {
          this.$root.showLoader = false;
          this.centers = response.map((x, i) => {
            let c = {};
            c.text = x.name;
            c.value = x.id;
            return c;
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    onCenterchange(centerIds) {
      this.selectedCenterId = centerIds;
    },
  },
  watch: {
    selectedCenterId(val) {
      this.error.center.type = null;
    },
    tab(){
      this.email = "";
      this.name = "";
      this.selectedCenterId = [];
      this.centers=[];
      if(this.tab=='Coordinator'){
        this.requestGetCenters();
      }

      this.error={
        email: {
          type: null,
          message: null,
        },
        name: {
          type: null,
          message: null,
        },
        center: {
          type: [],
          message: null,
        },
      };
    }
  },
  mounted() {
    this.requestGetCenters();
  },
};
</script>
